<template>
  <avatar-with-name :user="user" :styles="{ textClass }" />
</template>
<script setup lang="ts">
import { computed } from "vue";

import AvatarWithName from "@/components/ui/AvatarWithName.vue";

interface Props {
  sender: string | null;
  textClass: string;
}

const { sender, textClass } = defineProps<Props>();

const user = computed(() => {
  const [first_name, last_name] = sender?.split(" ") || [];
  return {
    first_name: first_name || "",
    last_name: last_name || "",
  };
});
</script>
